import {ReactElement} from "react";
import {Helmet} from "react-helmet-async";
import {Link} from "react-router";

import AccessDeniedHamster from "@/assets/images/access-denied-hamster.svg";
import {Button} from "@/components/button/Button.tsx";
import {Card} from "@/components/card/Card";
import ContentContainer from "@/components/layout/ContentContainer.tsx";

import styles from "./AccessDeniedBlock.module.scss";

interface AccessDeniedBlockProps {
  title: string;
  children: ReactElement;
}

export const AccessDeniedBlock = ({title, children}: AccessDeniedBlockProps) => {
  return (
    <ContentContainer title={title}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Card variant="white" className="mb-4 text-center p-5">
        <img src={AccessDeniedHamster} height={106} width={126} alt={title} />
        <div className={`${styles.accessDeniedBlock} fs-9 mt-3 mx-auto`}>
          {children}
          <div className="mt-4 d-flex align-items-center justify-content-around flex-wrap gap-3">
            <Button as={Link} variant={"secondary"} to="/dashboard">
              Go to Dashboard
            </Button>
            <Button as={Link} variant={"secondary"} to="/contact">
              Contact Support
            </Button>
          </div>
        </div>
      </Card>
    </ContentContainer>
  );
};
